import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { useDashboardRole } from "../../context/dashboardRole";
import { storage } from "../../utils";
import { loginDashboard } from "../../utils/dashboardAuth";
import "./SignIn.css";

const SignIn = () => {
  const { setToken } = useAppContext();
  const { refresh } = useDashboardRole();
  const [user_name, set_user_name] = useState("");
  const [password, set_password] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [mfaToken, setMfaToken] = useState(null);
  const [otp, setOtp] = useState("");
  const [recovery, setRecovery] = useState("");
  /** Presentation-only: which MFA field is emphasized (API still accepts either). */
  const [mfaView, setMfaView] = useState("otp");
  const history = useHistory();

  const finish = async (data) => {
    await storage.save("token", data.token);
    if (data.role) await storage.save("role", data.role);
    setToken(data.token);
    if (typeof refresh === "function") {
      await refresh();
    }
    history.replace("/dashboard");
  };

  const onLogin = async () => {
    setLoading(true);
    setError("");
    const res = await loginDashboard({ user_name, password });
    setLoading(false);
    if (!res.ok) {
      setError(res.message || "نام کاربری یا رمز عبور نادرست است.");
      return;
    }
    if (res.data.mfa_required) {
      setMfaToken(res.data.mfa_token);
      setMfaView("otp");
      return;
    }
    if (res.data.token) await finish(res.data);
  };

  const onMfa = async () => {
    setLoading(true);
    setError("");
    const res = await loginDashboard({
      mfa_token: mfaToken,
      otp: otp || undefined,
      recovery_code: recovery || undefined,
    });
    setLoading(false);
    if (!res.ok || !res.data.token) {
      setError(res.message || "نام کاربری یا رمز عبور نادرست است.");
      return;
    }
    await finish(res.data);
  };

  const onPasswordKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      e.preventDefault();
      onLogin();
    }
  };

  const onMfaKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      e.preventDefault();
      onMfa();
    }
  };

  return (
    <div className="puSignIn" lang="fa">
      <div className="puSignIn__shell">
        <div className="puSignIn__formPanel">
          <span className="puSignIn__accent" aria-hidden="true" />
          <h1 className="puSignIn__title">ورود به پنل پایپ‌آپ</h1>
          <p className="puSignIn__subtitle">مدیریت سفارش‌ها و درخواست‌های قیمت</p>

          {error ? (
            <div className="puSignIn__error" role="alert">
              {error}
            </div>
          ) : null}

          {!mfaToken ? (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onLogin();
              }}
              noValidate
            >
              <div className="puSignIn__field">
                <label className="puSignIn__label" htmlFor="pu-signin-username">
                  نام کاربری
                </label>
                <input
                  id="pu-signin-username"
                  name="username"
                  type="text"
                  className="puSignIn__input"
                  placeholder="نام کاربری"
                  dir="ltr"
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  value={user_name}
                  disabled={loading}
                  onChange={(e) => set_user_name(e.target.value)}
                  onKeyDown={onPasswordKeyDown}
                />
              </div>
              <div className="puSignIn__field">
                <label className="puSignIn__label" htmlFor="pu-signin-password">
                  رمز عبور
                </label>
                <input
                  id="pu-signin-password"
                  name="password"
                  type="password"
                  className="puSignIn__input"
                  placeholder="رمز عبور"
                  dir="ltr"
                  autoComplete="current-password"
                  value={password}
                  disabled={loading}
                  onChange={(e) => set_password(e.target.value)}
                  onKeyDown={onPasswordKeyDown}
                />
              </div>
              <div className="puSignIn__actions">
                <button
                  type="submit"
                  className="puSignIn__btn puSignIn__btn--primary"
                  disabled={loading}
                >
                  {loading ? "در حال ورود…" : "ورود"}
                </button>
              </div>
            </form>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onMfa();
              }}
              noValidate
            >
              <div className="puSignIn__tabs" role="tablist" aria-label="روش تأیید">
                <button
                  type="button"
                  role="tab"
                  aria-selected={mfaView === "otp"}
                  className={
                    "puSignIn__tab" +
                    (mfaView === "otp" ? " puSignIn__tab--active" : "")
                  }
                  onClick={() => setMfaView("otp")}
                >
                  کد Authenticator
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={mfaView === "recovery"}
                  className={
                    "puSignIn__tab" +
                    (mfaView === "recovery" ? " puSignIn__tab--active" : "")
                  }
                  onClick={() => setMfaView("recovery")}
                >
                  کد بازیابی
                </button>
              </div>

              {mfaView === "otp" ? (
                <>
                  <p className="puSignIn__hint">
                    کد ۶ رقمی اپلیکیشن Authenticator را وارد کنید.
                  </p>
                  <div className="puSignIn__field">
                    <label className="puSignIn__label" htmlFor="pu-signin-otp">
                      کد یک‌بارمصرف
                    </label>
                    <input
                      id="pu-signin-otp"
                      name="otp"
                      type="text"
                      inputMode="numeric"
                      className="puSignIn__input"
                      placeholder="کد ۶ رقمی"
                      dir="ltr"
                      autoComplete="one-time-code"
                      value={otp}
                      disabled={loading}
                      onChange={(e) => setOtp(e.target.value)}
                      onKeyDown={onMfaKeyDown}
                    />
                  </div>
                </>
              ) : (
                <>
                  <p className="puSignIn__hint">
                    یکی از کدهای بازیابی ذخیره‌شده را وارد کنید. هر کد فقط یک‌بار
                    قابل استفاده است.
                  </p>
                  <div className="puSignIn__field">
                    <label
                      className="puSignIn__label"
                      htmlFor="pu-signin-recovery"
                    >
                      کد بازیابی
                    </label>
                    <input
                      id="pu-signin-recovery"
                      name="recovery_code"
                      type="text"
                      className="puSignIn__input"
                      placeholder="کد بازیابی"
                      dir="ltr"
                      autoComplete="off"
                      value={recovery}
                      disabled={loading}
                      onChange={(e) => setRecovery(e.target.value)}
                      onKeyDown={onMfaKeyDown}
                    />
                  </div>
                </>
              )}

              <div className="puSignIn__actions">
                <button
                  type="submit"
                  className="puSignIn__btn puSignIn__btn--primary"
                  disabled={loading}
                >
                  {loading ? "در حال تأیید…" : "تأیید"}
                </button>
                <button
                  type="button"
                  className="puSignIn__btn puSignIn__btn--ghost"
                  disabled={loading}
                  onClick={() => {
                    setMfaToken(null);
                    setOtp("");
                    setRecovery("");
                    setError("");
                    setMfaView("otp");
                  }}
                >
                  بازگشت به ورود با رمز
                </button>
              </div>
            </form>
          )}
        </div>

        <aside className="puSignIn__brand" aria-hidden="true">
          <svg
            className="puSignIn__deco"
            viewBox="0 0 400 560"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid slice"
          >
            <g
              fill="none"
              stroke="rgba(255,255,255,0.55)"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M48 420 H160" />
              <path d="M160 420 V300" />
              <path d="M160 300 H280" />
              <path d="M280 300 V180" />
              <path d="M280 180 H352" />
              <path d="M72 480 H200" />
              <path d="M200 480 V360" />
              <path d="M200 360 H320" />
              <path d="M100 120 H220" />
              <path d="M220 120 V220" />
              <path d="M220 220 H340" />
              <circle cx="160" cy="420" r="6" fill="rgba(200,16,46,0.85)" stroke="none" />
              <circle cx="280" cy="300" r="6" fill="rgba(200,16,46,0.85)" stroke="none" />
              <circle cx="200" cy="360" r="5" fill="rgba(255,255,255,0.7)" stroke="none" />
            </g>
          </svg>
          <div className="puSignIn__brandInner">
            <img
              className="puSignIn__logo"
              src="/pipeup-dashboard-brand-logo.png"
              alt=""
            />
            <p className="puSignIn__brandMark">پایپ‌آپ</p>
            <p className="puSignIn__brandHint">
              پنل مدیریت سفارش‌ها و درخواست‌های قیمت
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
};

export { SignIn };
